'use client';

import { useState } from 'react';
import { TextLink, Drawer, Heading, IconMediaBlock } from '@petsmart-ui/sparky';
import type { CurbsideDrawerProps } from '@app/pdp/components/AddToCart/DeliveryMethods/types';
import { useDecisions } from '@libs/common-next';

export default function CurbsideDrawer({ curbsideInfo }: CurbsideDrawerProps) {
    const [isActive, setisActive] = useState(false);
    // Add opti decision to swap Delivery Method
    const flag = 'dpt_6219_autoship';
    const decision = useDecisions(flag);
    const isActiveDecision = decision == 'tiles' || decision == 'tiles_image';
    return (
        <div
            className={`curbside-info ${
                isActiveDecision ? 'curbside-opti' : ''
            }`}
        >
            <IconMediaBlock
                className="curbside-available"
                verticalAlign="center"
                iconName="car"
                variant="bare"
                {...(isActiveDecision ? { iconSize: 'md' } : {})}
            >
                {isActiveDecision
                    ? 'Curbside pickup available'
                    : 'Curbside available'}
            </IconMediaBlock>
            <TextLink
                data-testid="learn-more"
                onClick={() => setisActive(true)}
                className="curbside-learn-more"
            >
                {isActiveDecision ? 'Details' : 'Learn more'}
            </TextLink>
            <Drawer
                align="right"
                className="added-to-cart-drawer curbside-drawer"
                data-testid="curbside-drawer"
                isActive={isActive}
                onClose={() => setisActive(false)}
                dismissible
            >
                <Drawer.Header>
                    <Heading size="headline" tagName="h2">
                        {curbsideInfo.header}
                    </Heading>
                </Drawer.Header>
                <Drawer.Body>{curbsideInfo.body}</Drawer.Body>
                {curbsideInfo.footer && (
                    <Drawer.Footer>{curbsideInfo.footer}</Drawer.Footer>
                )}
            </Drawer>
        </div>
    );
}
